export const formatRequestTags = (tags: Array<{ name?: string | null } | null> | null | undefined) =>
    (tags ?? [])
        .map(tag => tag?.name?.trim())
        .filter((name): name is string => !!name)
        .join(', ');

export const formatApplicationName = (applicationName: string | null | undefined) =>
    applicationName?.trim() || '—';
